import { createAction } from '@reduxjs/toolkit';

export const setTargetCurrency = createAction('SET_TARGET_CURRENCY');
